import { apiFetch } from '../../shared/api/httpClient';

export type ArchiveAnchor = {
  number?: number | null;
  hash?: string | null;
  timestamp?: number | null;
  timestamp_iso?: string | null;
};

export type ArchiveRound = {
  round_number: number;
  utc_date?: string;
  starts_at?: number;
  ends_at?: number;
  cutoff_ts?: number;
  status?: string;
  anchors?: ArchiveAnchor[];
  eth_digits?: Array<string | number[] | null>;
  draw_digits?: string | number[];
  games?: {
    lastdigit?: number | null;
    sicbo?: number[] | null;
    roulette?: number | null;
  } | null;
};

export type ArchiveRoundsResponse = {
  date: string;
  rounds?: ArchiveRound[];
};

// The moment the draw is fully determined = the timestamp of the 3rd anchor block
// (the last of the 3 public ETH blocks the result is derived from). This is the
// real "draw time". Falls back to the round's close time if the 3rd block is
// missing/pending.
export function drawResolvedTs(round: ArchiveRound): number {
  const anchors = round.anchors || [];
  const third = Number(anchors[2]?.timestamp || 0);
  return third || Number(round.ends_at || round.cutoff_ts || round.starts_at || 0);
}

export function fetchArchiveRounds(date: string, limit = 288) {
  return apiFetch<ArchiveRoundsResponse>(`/api/rounds?date=${encodeURIComponent(date)}&limit=${limit}`, {
    cache: 'no-store',
  });
}

// Fetch a single round by its global round number — the same serializer the day
// list uses, so the response is one ArchiveRound. Lets a deep-link (e.g. a
// raffle's anchor round) open any round's detail directly, without knowing or
// loading its day. 404s throw (round not found).
export function fetchRoundByNumber(roundNumber: number) {
  return apiFetch<ArchiveRound>(`/api/round/${encodeURIComponent(roundNumber)}`, {
    cache: 'no-store',
  });
}
